import { Link } from 'react-router-dom';
import { getGossips, getNews, allStars } from '@/utils/articles';

const entries = [
  {
    to: '/category/feiwen',
    title: '娱乐黑料',
    desc: '绯闻、内幕、片场风波，最热爆料一网打尽',
    icon: 'ri-flashlight-line',
    tone: 'primary',
  },
  {
    to: '/news',
    title: '热点资讯',
    desc: '颁奖礼、行业动态、活动报道综合呈现',
    icon: 'ri-newspaper-line',
    tone: 'accent',
  },
  {
    to: '/star',
    title: '明星专题',
    desc: '聚焦当红明星的爆料合集与个人档案',
    icon: 'ri-user-star-line',
    tone: 'secondary',
  },
];

const toneMap: Record<string, string> = {
  primary: 'bg-primary-500 text-background-50',
  accent: 'bg-accent-500 text-background-50',
  secondary: 'bg-secondary-500 text-background-50',
};

export default function CategoryEntries() {
  const counts: Record<string, number> = {
    '/category/feiwen': getGossips().length,
    '/news': getNews().length,
    '/star': allStars.length,
  };

  return (
    <section className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
      {entries.map((entry) => (
        <Link
          key={entry.to}
          to={entry.to}
          className="group flex items-center gap-4 p-4 md:p-5 bg-background-50 border border-background-200 rounded-lg hover:border-primary-300 transition-colors"
        >
          <span
            className={`w-12 h-12 md:w-14 md:h-14 rounded-lg flex items-center justify-center shrink-0 ${toneMap[entry.tone]}`}
          >
            <i className={`${entry.icon} text-2xl md:text-3xl`}></i>
          </span>
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <h3 className="text-base font-black text-foreground-950 group-hover:text-primary-600 transition-colors">
                {entry.title}
              </h3>
              <span className="text-xs text-foreground-500">{counts[entry.to]} 条</span>
            </div>
            <p className="text-xs md:text-sm text-foreground-600 mt-1 line-clamp-1">{entry.desc}</p>
          </div>
          <i className="ri-arrow-right-line text-foreground-400 group-hover:text-primary-600 group-hover:translate-x-1 transition-all"></i>
        </Link>
      ))}
    </section>
  );
}